import { importProvidersFrom } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { reducer, rootInitialState } from "../../ngrx/reducers";
import { MapEffects } from "../../ngrx/effects/map";
import { CustomViewEffects } from "../../ngrx/effects/custom-view";

/**
 * Returns providers that import NgRx Store and Effects modules so they can be
 * reused in application bootstrap and in tests.
 *
 * The function accepts an optional initialState which is forwarded to
 * StoreModule.forRoot. Tests can call this with a mocked initial state.
 */
export function provideNgRx(initialState: typeof rootInitialState = rootInitialState) {
  return importProvidersFrom(
    StoreModule.forRoot({ igv: reducer }, { initialState }),
    EffectsModule.forRoot([MapEffects, CustomViewEffects])
  );
}
